import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContactFields } from '../interfaces/contact-fields.interface';
import { FileUploadContent } from '../interfaces/file-upload-content.interface';

@Injectable({
  providedIn: 'root'
})
export class MailHelperService {
  readonly url: string = 'mail';
  
  constructor(private http: HttpClient) {}

  public postTestMail(fileUploadedContent: FileUploadContent[], contactFields: ContactFields): Observable<boolean> {

    const formData: FormData = new FormData();

    fileUploadedContent.forEach(e => {
      formData.append(e.file.name, e.file);
    })

    formData.append("name", contactFields.name);
    formData.append("email", contactFields.email);
    formData.append("phoneNumber", contactFields.phoneNumber);
    formData.append("question", contactFields.question);
    formData.append("subject", contactFields.subject);

		return this.http.post<boolean>(this.url, formData);
	}
}
